import react.Props
import react.State

external interface stoneSampleProp : Props {
    var stoneType: AsPacStoneType
}

enum class AsPacStoneType(val stoneName: String) {
    GRANITE("granite"),
    MARBLE("marble"),
    QUARTZ("quartz"),
    LIMESTONE("limestone");

    companion object {
        fun getStoneName(stoneName: String) = valueOf(stoneName.uppercase())
    }
}

external interface sampleProp: Props {
    var highIterator: Int
    var stoneType: AsPacStoneType

}

external interface CareProps : Props {
    var stoneType: String
}

external interface CareState : State {
    var stoneType: String
}

data class StoneSample (val name: String, val filename: String)